import { generate } from "shortid";
import { PAGE_TYPES, PAGE_THEMES, PAGE_PATH } from "../types";

export const CHOOSE_PERSON_PAGES = {
  choose_path_page: {
    id: `choose_path_page-${generate()}`,
    type: PAGE_TYPES.singleSelect,
    title: null,
    backwards_navigation_enabled: false,
    target_state: "welcome_data",
    target_field: "choose_path",
    target_pages: [
      {
        name: "get_started_page",
        data_key: "default_progression",
        action: (data) => {
          if (data === PAGE_PATH.parent) {
            return "parent_choose_child_phobia_page";
          }

          return "choose_problem_page";
        },
      },
    ],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "How will you use the platform?",
      description: null,
      image: null,
      custom_back: null,
      default_progression: "choose_problem_page",
      footer_message:
        '<div style="margin-top: 10rem"><b style="color:#49323E">Referred from Reliant Medical Group?</b><p style="color:#76656E">Please wait for your provider\'s invitation email or text to register. Missing it? Contact us at <a href="mailto:support@ovrcome.io">support@ovrcome.io</a>.</p></div>',
      options: [
        {
          id: `option-item-2-${generate()}`,
          label: `As a clinician with clients`,
          icon: "clinician",
          value: "open_clinician_portal",
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-0-${generate()}`,
          label: "Independently, as an adult",
          to: "get_started_page",
          icon: "individual",
          value: "myself",
          target_field: "choose_path",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
};
